/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfEnrollmentAcceptedDto } from "../models/AjaxResponseOfEnrollmentAcceptedDto";
import type { AjaxResponseOfEnrollmentActivationExchangeDto } from "../models/AjaxResponseOfEnrollmentActivationExchangeDto";
import type { AjaxResponseOfEnrollmentActivationResendDto } from "../models/AjaxResponseOfEnrollmentActivationResendDto";
import type { AjaxResponseOfEnrollmentAuthorizationDto } from "../models/AjaxResponseOfEnrollmentAuthorizationDto";
import type { AjaxResponseOfEnrollmentConfigurationDto } from "../models/AjaxResponseOfEnrollmentConfigurationDto";
import type { AjaxResponseOfEnrollmentRetryDto } from "../models/AjaxResponseOfEnrollmentRetryDto";
import type { AjaxResponseOfEnrollmentStatusDto } from "../models/AjaxResponseOfEnrollmentStatusDto";
import type { ConfirmExistingEnrollmentIdentityInput } from "../models/ConfirmExistingEnrollmentIdentityInput";
import type { CreateEnrollmentAuthorizationInput } from "../models/CreateEnrollmentAuthorizationInput";
import type { CreateSelfServiceEnrollmentInput } from "../models/CreateSelfServiceEnrollmentInput";
import type { ExchangeEnrollmentActivationInput } from "../models/ExchangeEnrollmentActivationInput";
import type { IssueExistingEnrollmentAuthorizationInput } from "../models/IssueExistingEnrollmentAuthorizationInput";
import type { ResendEnrollmentActivationInput } from "../models/ResendEnrollmentActivationInput";
import type { ResendEnrollmentOtpInput } from "../models/ResendEnrollmentOtpInput";
import type { VerifyEnrollmentOtpInput } from "../models/VerifyEnrollmentOtpInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class SelfServiceEnrollmentsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfEnrollmentAcceptedDto Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateSelfServiceEnrollmentInput;
  }): CancelablePromise<AjaxResponseOfEnrollmentAcceptedDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
        429: `Client Error`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentAuthorizationDto Success
   * @throws ApiError
   */
  public authorizeEnrollment({
    requestBody,
  }: {
    requestBody?: CreateEnrollmentAuthorizationInput;
  }): CancelablePromise<AjaxResponseOfEnrollmentAuthorizationDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments/authorization",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        401: `Unauthorized`,
        409: `Conflict`,
        429: `Client Error`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentConfigurationDto Success
   * @throws ApiError
   */
  public getConfiguration({
    productCode,
  }: {
    productCode?: string;
  }): CancelablePromise<AjaxResponseOfEnrollmentConfigurationDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/public/v1/enrollments/configuration",
      query: {
        productCode: productCode,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentStatusDto Success
   * @throws ApiError
   */
  public get({
    publicId,
  }: {
    publicId: string;
  }): CancelablePromise<AjaxResponseOfEnrollmentStatusDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/public/v1/enrollments/{publicId}",
      path: {
        publicId: publicId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentRetryDto Success
   * @throws ApiError
   */
  public retry({
    publicId,
  }: {
    publicId: string;
  }): CancelablePromise<AjaxResponseOfEnrollmentRetryDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments/{publicId}/retry",
      path: {
        publicId: publicId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentActivationResendDto Success
   * @throws ApiError
   */
  public resendActivation({
    publicId,
    xEnrollmentBffSecret,
    requestBody,
  }: {
    publicId: string;
    xEnrollmentBffSecret: string;
    requestBody?: ResendEnrollmentActivationInput;
  }): CancelablePromise<AjaxResponseOfEnrollmentActivationResendDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments/{publicId}/activation/resend",
      path: {
        publicId: publicId,
      },
      headers: {
        "X-Enrollment-Bff-Secret": xEnrollmentBffSecret,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentAcceptedDto Success
   * @throws ApiError
   */
  public confirmExistingIdentity({
    publicId,
    requestBody,
  }: {
    publicId: string;
    requestBody?: ConfirmExistingEnrollmentIdentityInput;
  }): CancelablePromise<AjaxResponseOfEnrollmentAcceptedDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments/{publicId}/identity/confirm",
      path: {
        publicId: publicId,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentAuthorizationDto Success
   * @returns AjaxResponseOfEnrollmentAcceptedDto Success
   * @throws ApiError
   */
  public authorizeExistingIdentity({
    publicId,
    requestBody,
  }: {
    publicId: string;
    requestBody?: IssueExistingEnrollmentAuthorizationInput;
  }): CancelablePromise<
    | AjaxResponseOfEnrollmentAuthorizationDto
    | AjaxResponseOfEnrollmentAcceptedDto
  > {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments/{publicId}/identity/authorization",
      path: {
        publicId: publicId,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentActivationExchangeDto Success
   * @returns AjaxResponseOfEnrollmentAcceptedDto Success
   * @throws ApiError
   */
  public exchangeActivation({
    publicId,
    xEnrollmentBffSecret,
    requestBody,
  }: {
    publicId: string;
    xEnrollmentBffSecret: string;
    requestBody?: ExchangeEnrollmentActivationInput;
  }): CancelablePromise<
    | AjaxResponseOfEnrollmentActivationExchangeDto
    | AjaxResponseOfEnrollmentAcceptedDto
  > {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments/{publicId}/activation/exchange",
      path: {
        publicId: publicId,
      },
      headers: {
        "X-Enrollment-Bff-Secret": xEnrollmentBffSecret,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentAcceptedDto Success
   * @throws ApiError
   */
  public resendOtp({
    publicId,
    xEnrollmentBffSecret,
    requestBody,
  }: {
    publicId: string;
    xEnrollmentBffSecret?: string;
    requestBody?: ResendEnrollmentOtpInput;
  }): CancelablePromise<AjaxResponseOfEnrollmentAcceptedDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments/{publicId}/otp/resend",
      path: {
        publicId: publicId,
      },
      headers: {
        "x-Enrollment-Bff-Secret": xEnrollmentBffSecret,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfEnrollmentAcceptedDto Success
   * @throws ApiError
   */
  public verifyOtp({
    publicId,
    xEnrollmentBffSecret,
    requestBody,
  }: {
    publicId: string;
    xEnrollmentBffSecret?: string;
    requestBody?: VerifyEnrollmentOtpInput;
  }): CancelablePromise<AjaxResponseOfEnrollmentAcceptedDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/public/v1/enrollments/{publicId}/otp/verify",
      path: {
        publicId: publicId,
      },
      headers: {
        "x-Enrollment-Bff-Secret": xEnrollmentBffSecret,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
      },
    });
  }
}
